import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  FunctionField,
  useListContext,
  BulkDeleteWithConfirmButton,
  RecordContextProvider,
  ChipField,
  BooleanField,
  useResourceContext,
  useTheme,
} from "react-admin";
import BadDebtAddDialog from "../../components/badDebts/create/BadDebtAddDialog";
import BadDebtEditDialog from "../../components/badDebts/edit/BadDebtEditDialog";
import badDebtFilterList from "../../components/badDebts/filter/badDebtFilterList";
import TableListActions from "../../components/tableListActions/TableListActions";
import BadDebtExpandList from "../../components/badDebts/expand/BadDebtExpandList";
import ConfirmBtn from "../../components/confirmBtn/ConfirmBtn";
import EditBtn from "../../components/editBtn/EditBtn";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const Aside = () => {
  const auy = useListContext();
  return (
    <div style={{ width: 200, margin: "1em" }}>
      <Typography variant="h6">Posts stats</Typography>
      <Typography variant="body2">
        Total views:{" "}
        {/* {ids.map((id) => data[id]).reduce((sum, post) => sum + post.views, 0)} */}
      </Typography>
    </div>
  );
};

const BadDebtList = () => {
  const resource = useResourceContext();
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [showAside, setShowAside] = useState(false);
  const [theme] = useTheme("light");

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const ketemplag = (id, basePath, record) => {
    // console.log("Lets", id, basePath, record);
    // setShowAside((prev) => !prev);
  };
  const list = useMemo(
    () => (
      <List
        title="mine.list_title.bad_debt"
        empty={false}
        aside={showAside ? <Aside /> : null}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
            createPermission="create_bad_debt"
          />
        }
        filters={badDebtFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
      >
        <DatagridConfigurable
          bulkActionButtons={
            // openAdd || openEdit ? false :
            <BulkDeleteWithConfirmButton />
          }
          rowClick={ketemplag}
          expand={<BadDebtExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <FunctionField
            label="mine.label.customer"
            render={(record) =>
              `${record.customer.name} (${record.customer.code})`
            }
          />
          <FunctionField
            textAlign="center"
            label="mine.label.type"
            render={(record) => {
              let rec = {};
              if (record.type === 1) {
                rec.type = "Bad Debt";
                rec.color = "error";
              } else if (record.type === 2) {
                rec.type = "Cicilan";
                rec.color = "success";
              }
              return (
                <RecordContextProvider value={rec}>
                  <ChipField source="type" color={rec.color} size="small" />
                </RecordContextProvider>
              );
            }}
          />
          <BooleanField
            source="approved"
            label="mine.label.approved"
            textAlign="center"
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              render={(record) => {
                return record.approved ? (
                  permissions && permissions.administrator ? (
                    <ConfirmBtn
                      title="mine.message.unapprove"
                      content="mine.message.unapprove_content"
                      label="mine.label.unapprove"
                      resource={resource + "/unapprove"}
                      startIcon={<CloseIcon />}
                      color="error"
                    />
                  ) : null
                ) : (
                  <>
                    <EditBtn
                      editHandler={handleClickOpenEdit(record.id)}
                      sx={{ mr: 1 }}
                    />
                    <ConfirmBtn
                      title="mine.message.approve"
                      content="mine.message.approve_content"
                      label="mine.btn.approve"
                      resource={resource + "/approve"}
                      startIcon={<DoneIcon />}
                    />
                  </>
                );
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [
      showAside,
      openAdd,
      openEdit,
      theme,
      permissions,
      canSeeCompanyColumn,
      filterDefaultValues,
    ]
  );
  return (
    <>
      {list}
      <BadDebtAddDialog open={openAdd} setOpen={setOpenAdd} />
      <BadDebtEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default BadDebtList;
